(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = document.documentElement;

  const revealSelectors = [
    '.cc-journey',
    '.cc-archive-ticket-group',
    '.cc-archive-hospitality-banner',
    '.cc-hp__main',
    '.cc-summary',
    '.cc-product__media',
    '.cc-product__booking',
    '.cc-ticket-cart__item',
    '.cc-ticket-cart__summary',
    '.cc-archive-home section',
    '.cc-home-partners',
    '.cc-home-assurance'
  ];

  const reveals = Array.from(document.querySelectorAll(revealSelectors.join(',')));
  reveals.forEach((node, index) => {
    node.setAttribute('data-cc-reveal', '');
    node.style.setProperty('--cc-reveal-delay', Math.min(index % 6, 5) * 45 + 'ms');
  });

  if (reduceMotion || !('IntersectionObserver' in window)) {
    reveals.forEach((node) => node.classList.add('is-visible'));
  } else {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    reveals.forEach((node) => observer.observe(node));
  }

  requestAnimationFrame(() => {
    root.classList.add('cc-page-ready');
  });

  const shouldNavigate = (event, anchor) => {
    if (!anchor || event.defaultPrevented || event.button !== 0) return false;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (anchor.hasAttribute('download') || anchor.target === '_blank') return false;
    if (anchor.dataset.noPageTransition != null) return false;

    let target;
    try { target = new URL(anchor.href, window.location.href); } catch (_) { return false; }
    if (target.origin !== window.location.origin) return false;
    if (target.pathname === window.location.pathname && target.search === window.location.search && target.hash) return false;
    if (target.protocol !== 'http:' && target.protocol !== 'https:') return false;
    return true;
  };

  document.addEventListener('click', (event) => {
    if (reduceMotion) return;
    const anchor = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!shouldNavigate(event, anchor)) return;

    const target = new URL(anchor.href, window.location.href);
    event.preventDefault();
    root.classList.add('cc-page-leaving');
    window.setTimeout(() => {
      window.location.assign(target.href);
    }, 180);
  }, false);

  window.addEventListener('pageshow', () => {
    root.classList.remove('cc-page-leaving');
    root.classList.add('cc-page-ready');
  });
})();